// react
import React, {useEffect, useReducer, useState} from 'react';

// third-party
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet-async';

// application
import BlockLoader from '../blocks/BlockLoader';
import PageHeader from '../shared/PageHeader';
import ProductsView from './ProductsView';
import {sidebarClose} from '../../store/sidebar';

// data stubs
import theme from '../../data/theme';
import {url, getCategoryParents} from '../../services/utils';
import {useHistory, useParams} from "react-router-dom";
import {useProductsContext} from "../../providers/DataProvider";
import RangeFilterBuilder from "../../fake-server/filters/price";

const customSubCategoryQuery = (data, options = {}, filterValues = {}) => {
    const filters = [
        //new CategoryFilterBuilder('category', 'Categorie'),
        new RangeFilterBuilder('price', 'Prezzo'),
        // new CheckFilterBuilder('brand', 'Brand'),
    ];

    let items = data;

    filters.forEach((filter) => filter.makeItems(items, filterValues[filter.slug]));

    // Calculate items count for filter values.
    // filters.forEach((filter) => filter.calc(filters));

    // Apply filters to products list.
    /*items = items.filter(
        (product) => filters.reduce((mr, filter) => mr && filter.test(product), true),
    );*/

    const page = options.page || 1;
    const limit = options.limit || 12;
    const sort = options.sort || 'default';
    const total = items.length;
    const pages = Math.ceil(total / limit);
    const from = (page - 1) * limit + 1;
    const to = Math.max(Math.min(page * limit, total), from);

    items = items.sort((a, b) => {
        if (['name_asc', 'name_desc'].includes(sort)) {
            if (a.name === b.name) {
                return 0;
            }

            return (a.name > b.name ? 1 : -1) * (sort === 'name_asc' ? 1 : -1);
        }

        return 0;
    });

    const start = (page - 1) * limit;
    const end = start + limit;

    items = items.slice(start, end);

    return {
        page,
        limit,
        sort,
        total,
        pages,
        from,
        to,
        items,
        filters: filters.map((x) => x.build()),
    }
}
function parseQueryOptions(location) {
    const query = queryString.parse(location);
    const optionValues = {};

    if (typeof query.page === 'string') {
        optionValues.page = parseFloat(query.page);
    }
    if (typeof query.limit === 'string') {
        optionValues.limit = parseFloat(query.limit);
    }
    if (typeof query.sort === 'string') {
        optionValues.sort = query.sort;
    }

    return optionValues;
}

function parseQueryFilters(location) {
    const query = queryString.parse(location);
    const filterValues = {};

    Object.keys(query).forEach((param) => {
        const mr = param.match(/^filter_([-_A-Za-z0-9]+)$/);

        if (!mr) {
            return;
        }

        const filterSlug = mr[1];

        filterValues[filterSlug] = query[param];
    });

    return filterValues;
}

function parseQuery(location) {
    return [
        parseQueryOptions(location),
        parseQueryFilters(location),
    ];
}

function buildQuery(options, filters) {
    const params = {};

    if (options.page !== 1) {
        params.page = options.page;
    }

    if (options.limit !== 12) {
        params.limit = options.limit;
    }

    if (options.sort !== 'default') {
        params.sort = options.sort;
    }

    Object.keys(filters).filter((x) => x !== 'category' && !!filters[x]).forEach((filterSlug) => {
        params[`filter_${filterSlug}`] = filters[filterSlug];
    });

    return queryString.stringify(params, {encode: false});
}

const initialState = {
    init: false,
    /**
     * Indicates that the category is loading.
     */
    categoryIsLoading: true,
    /**
     * Category object.
     */
    category: null,
    /**
     * Indicates that the products list is loading.
     */
    productsListIsLoading: true,
    /**
     * Products list.
     */
    productsList: null,
    /**
     * Products list options.
     *
     * options.page:  number - Current page.
     * options.limit: number - Items per page.
     * options.sort:  string - Sort algorithm.
     */
    options: {},
    /**
     * Products list filters.
     *
     * filters[FILTER_SLUG]: string - filter value.
     */
    filters: {},
};

function reducer(state, action) {
    switch (action.type) {
        case 'FETCH_SUB_CATEGORY_SUCCESS':
            return {
                ...state,
                init: true,
                categoryIsLoading: false,
                category: action.category,
            };
        case 'FETCH_PRODUCTS_LIST':
            return {...state, productsListIsLoading: true};
        case 'FETCH_PRODUCTS_LIST_SUCCESS':
            return {...state, productsListIsLoading: false, productsList: action.productsList};
        case 'SET_OPTION_VALUE':
            return {
                ...state,
                options: {...state.options, page: 1, [action.option]: action.value},
            };
        case 'SET_FILTER_VALUE':
            return {
                ...state,
                options: {...state.options, page: 1},
                filters: {...state.filters, [action.filter]: action.value},
            };
        case 'RESET_FILTERS':
            return {...state, options: {...state.options, page: 1}, filters: {}};
        case 'RESET':
            return state.init ? initialState : state;
        default:
            throw new Error();
    }
}

function init(state) {
    const [options, filters] = parseQuery(window.location.search);

    return {...state, options, filters};
}

function ShopPageSubCategory(props) {
    const {
        columns,
        viewMode,
        sidebarPosition,
    } = props;
    const offcanvas = columns === 3 ? 'mobile' : 'always';
    const [state, dispatch] = useReducer(reducer, initialState, init);
    const [,setLatestProducts] = useState([]);
    const {subCategorySlug,categorySlug} = useParams();
    const {getLatestProducts, getProductsByCategorySlug, getSubCategoryBySlug} = useProductsContext();

    const navigate = useHistory();

    // Replace current url.
    useEffect(() => {
        const query = buildQuery(state.options, state.filters);
        const location = `${window.location.pathname}${query ? '?' : ''}${query}`;

        window.history.replaceState(null, '', location);
    }, [state.options, state.filters]);

    // Load category.
    useEffect(() => {
        let request;
        let canceled = false;

        dispatch({type: 'RESET'});

        if (subCategorySlug) {
            request = getSubCategoryBySlug(subCategorySlug);
        } else {
            request = null;
        }

        if (request) {
            dispatch({type: 'FETCH_SUB_CATEGORY_SUCCESS', category: request});
        } else return;

        return () => {
            canceled = true;
        };
    }, [dispatch, subCategorySlug]);

    // Load products.
    useEffect(() => {
        let prodottiSub;
        if (subCategorySlug && categorySlug) {
            const productByCategorySlug = getProductsByCategorySlug(categorySlug);
            prodottiSub = productByCategorySlug.filter(p => p.attributes.sub_categories.data.find(s => s.attributes.slug === subCategorySlug))
        } else {
            prodottiSub = [];
        }
        if(prodottiSub.length === 0) {
            navigate.push('/404');
            return;
        }

        dispatch({type: 'FETCH_PRODUCTS_LIST_SUCCESS', productsList: customSubCategoryQuery(prodottiSub, state.options,
                {...state.filters})});
    }, [dispatch, subCategorySlug, state.options, state.filters]);

    // Load latest products.
    useEffect(() => {
        if (offcanvas === 'always') {
            setLatestProducts([]);
        } else {
            setLatestProducts(customSubCategoryQuery(getLatestProducts(), state.options,
                {...state.filters}));
        }
    }, [offcanvas]);

    if (state.categoryIsLoading || (state.productsListIsLoading && !state.productsList)) {
        return <BlockLoader/>;
    }

    const breadcrumb = [
        {title: 'Home', url: url.home()},
        {title: 'Shop', url: url.catalog()},
        {title: subCategorySlug, url: '/shop/catalog/subCategory/' + categorySlug + '/' + subCategorySlug}
    ];
    let pageTitle = 'Scintillante';
    let content;

    if (state.category) {
        getCategoryParents(state.category).forEach((parent) => {
            breadcrumb.push({title: parent.attributes.title, url: url.category(parent)});
        });

        breadcrumb.push({title: state.category.name, url: url.category(state.category)});

        pageTitle = state.category.name;
    }
    const productsView = (
        <ProductsView
            isLoading={state.productsListIsLoading}
            whiteLabel={false}
            productsList={state.productsList}
            options={state.options}
            filters={state.filters}
            dispatch={dispatch}
            layout={viewMode}
            grid={`grid-${columns}-${columns > 3 ? 'full' : 'sidebar'}`}
            offcanvas={offcanvas}
        />
    );
    // const sidebarComponent = (
    //     <CategorySidebar offcanvas={offcanvas}>
    //         <CategorySidebarItem>
    //             <WidgetFilters
    //                 title="Filters"
    //                 offcanvas={offcanvas}
    //                 filters={state.productsList.filters}
    //                 values={state.filters}
    //                 dispatch={dispatch}
    //             />
    //         </CategorySidebarItem>
    //         {offcanvas !== 'always' && (
    //             <CategorySidebarItem className="d-none d-lg-block">
    //                 <WidgetProducts title="Ultimi Prodotti" products={[]}/>
    //             </CategorySidebarItem>
    //         )}
    //     </CategorySidebar>
    // );

    if (columns > 3) {
        content = (
            <div className="container">
                <div className="block">{productsView}</div>
                {/*{sidebarComponent}*/}
            </div>
        );
    } else {
        // const sidebar = (
        //     <div className="shop-layout__sidebar">
        //         {/*{sidebarComponent}*/}
        //     </div>
        // );

        content = (
            <div className="container">
                <div className={`shop-layout shop-layout--sidebar--${sidebarPosition}`}>
                    <div className="shop-layout__content">
                        <div className="block">{productsView}</div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{`${state.category.attributes.title} — ${theme.name}`}</title>
            </Helmet>

            <PageHeader header={pageTitle} breadcrumb={breadcrumb}/>

            {content}
        </React.Fragment>
    );
}

ShopPageSubCategory.propTypes = {
    /**
     * number of product columns (default: 3)
     */
    columns: PropTypes.number,
    /**
     * mode of viewing the list of products (default: 'grid')
     * one of ['grid', 'grid-with-features', 'list']
     */
    viewMode: PropTypes.oneOf(['grid', 'grid-with-features', 'list']),
    /**
     * sidebar position (default: 'start')
     * one of ['start', 'end']
     * for LTR scripts "start" is "left" and "end" is "right"
     */
    sidebarPosition: PropTypes.oneOf(['start', 'end']),
};

ShopPageSubCategory.defaultProps = {
    columns: 3,
    viewMode: 'grid',
    sidebarPosition: 'start',
};

const mapStateToProps = (state) => ({
    sidebarState: state.sidebar,
    page: state.category,
});

const mapDispatchToProps = () => ({
    sidebarClose,
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopPageSubCategory);
